//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "",
  props: ['hardware_class'],
  data: function data() {
    return {
      option: {
        modem: '',
        phone1: '',
        memory: '',
        validity: '',
        interval: '',
        center: '',
        del_up_thr: '',
        automatic_del: false,
        del_low_thr: '',
        whitelist: [],
        delinterval: ''
      },
      validityPeriodList: [{
        label: "5分钟",
        value: "0"
      }, {
        label: "10分钟",
        value: "1"
      }, {
        label: "20分钟",
        value: "3"
      }, {
        label: "30分钟",
        value: "5"
      }, {
        label: "1小时",
        value: "11"
      }, {
        label: "6小时",
        value: "71"
      }, {
        label: "12小时",
        value: "143"
      }, {
        label: "1天",
        value: "167"
      }, {
        label: "5天",
        value: "171"
      }, {
        label: "10天",
        value: "176"
      }, {
        label: "20天",
        value: "186"
      }, {
        label: "30天",
        value: "196"
      }, {
        label: "5周",
        value: "197"
      }, {
        label: "10周",
        value: "202"
      }, {
        label: "20周",
        value: "212"
      }, {
        label: "30周",
        value: "222"
      }],
      isInput: false,
      inputValue: ""
    };
  },
  methods: {
    addWhite: function addWhite() {
      this.option.whitelist.push('');
    },
    removeWhite: function removeWhite(index) {
      this.option.whitelist.splice(index, 1);
    },
    saveClick: function saveClick() {
      this.$emit('save', {
        options: {
          modem: this.option.modem,
          phone1: this.option.phone1 ? this.option.phone1 : undefined,
          memory: this.option.memory,
          validity: this.option.validity,
          interval: this.option.interval,
          center: this.option.center ? this.option.center : undefined,
          delinterval: this.option.delinterval,
          del_up_thr: this.option.del_up_thr,
          automatic_del: this.option.automatic_del ? '1' : '0',
          del_low_thr: this.option.del_low_thr
        },
        lists: {
          whitelist: this.option.whitelist.filter(function (item) {
            return item.length > 0;
          })
        }
      });
    },
    refesh: function refesh() {
      this.$emit('refesh');
    },
    validityChange: function validityChange() {
      if (this.option.validity == -1) {
        this.isInput = true;
      }
    },
    inputBlur: function inputBlur() {
      if (this.inputValue == "" || this.inputValue == null) {
        this.isInput = false;
        return;
      }

      this.isInput = false;
      this.validityPeriodList.unshift({
        label: this.inputValue,
        value: this.inputValue
      });
      this.option.validity = this.inputValue;
      this.inputValue = "";
    }
  }
};